import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  public windowScroll: EventEmitter<any> = new EventEmitter<any>();
}
